///* ========================================================================== *
// * Created by Iskrzy
// * Rehaclinic Scripts
// * ========================================================================== */

function GetTrainerSchedule(data){
   showLoader(1);
   overlaySetContent($('#reservation_info').html());
   overlayContainerShow(); 
   hideLoader();  
   return false;
}

$(document).ready(function() { 
    function showTrainers(ref)
    {
        $resdiv = $('#trenerzy');
        if(typeof(ref)!== 'undefined' && ref!==''){
            var trainerpanels = $resdiv.find('.trainer-panel');
            if(trainerpanels.length){
                trainerpanels.removeClass('toshow'); 
                trainerpanels.each(function(e){ 
                   if($(this).hasClass(ref)) 
                       $(this).addClass('toshow');
                   else 
                       $(this).removeClass('toshow');
               });
            }

            var items = $resdiv.find('.trainer-panel.toshow');

            if($('.trainer-panel:not(.toshow)').length){
                $('.trainer-panel:not(.toshow)').fadeOut(function(){
                    if(items.length>0){
                      items.fadeIn();
                    }
                }); 
            } else { 
                if(items.length>0){
                            items.fadeIn();
                }
            } 
        } 
    }
    
    
      
    $('.selectpicker-choose-club').on('changed.bs.select', function (e) {
        showTrainers($(this).val());
        var phone = ($(this).find(":selected").data("phone"));
        $('#reception_phone').html('<a href="tel:+48'+phone.replace(/ /g,'')+'">'+phone+'</a>');
        
    });
});
